import { Directive, ElementRef, inject } from '@angular/core'

import { AuthService } from '../../../shared/services/auth.service'

@Directive({
	selector: '[appHideForDemoAccount]',
})
export class HideForDemoAccountDirective {
	private readonly element = inject(ElementRef)

	constructor(private readonly authService: AuthService) {
		if (this.authService.isDemoUser()) {
			this.element.nativeElement.style.display = 'none'
		}
	}
}
